//@ts-ignore
import { reportMessage } from '../raven-message';
import { getIsStorageAvailable } from './get-is-storage-available';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFromSessionStorage(key: string, defaultValue: any) {
    const isSessionStorageAvailable = getIsStorageAvailable('sessionStorage');

    if (typeof window !== 'undefined' && isSessionStorageAvailable) {
        return window.sessionStorage.getItem(key);
    }

    return defaultValue;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setToSessionStorage(key: string, value: any) {
    const isSessionStorageAvailable = getIsStorageAvailable('sessionStorage');

    if (typeof window !== 'undefined' && isSessionStorageAvailable) {
        window.sessionStorage.setItem(key, value);
    } else if (!isSessionStorageAvailable) {
        reportMessage('Session storage is unavailable');
    }
}

export function removeFromSessionStorage(key: string) {
    const isSessionStorageAvailable = getIsStorageAvailable('sessionStorage');

    if (typeof window !== 'undefined' && isSessionStorageAvailable) {
        window.sessionStorage.removeItem(key);
    } else if (!isSessionStorageAvailable) {
        reportMessage('Session storage is unavailable');
    }
}
